import ChatCard from '@/shared/chat-ui/ChatCard'
import { Button } from '@/shared/ui/button'
import { Home } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import TemplateCard from './TemplateCard'
import { useGetTemplates } from '../api/templates'
import { SetStateAction } from 'react'
import { Template } from '../types'
import { CreateThemeSteps } from '..'

type Props = {
  setStep: (id: CreateThemeSteps) => void;
  setTemplate: React.Dispatch<SetStateAction<Template | undefined>>
}

const TemplateSelection = ({ setTemplate, setStep }: Props) => {

  const { templatesData } = useGetTemplates()

  const navigate = useNavigate()

  return (
    <>
      <ChatCard user="client">
        <div className="w-full flex flex-col-reverse sm:flex-row justify-between items-end sm:items-center gap-3">

          <div className='flex items-center gap-1'>
            <Button
              onClick={() => navigate('/home?curr=navigation')}
              size="icon"
              variant="outline"
              className="rounded-full font-poppins border-2 border-purple-400 hover:bg-white tracking-wide text-purple-600"
            >
              <Home />
            </Button>
            <Button
              onClick={() => {
                setStep("create-theme")
                navigate('/home/create?opt=create-theme') 
              }}
              variant="outline"
              className="rounded-full font-poppins border-2 border-purple-400 hover:bg-white tracking-wide text-purple-600"
            >
              Return to create post
            </Button>
          </div>
          <p className="tracking-wide text-gray-500 font-poppins text-sm">I want to check something new</p>
        </div>
      </ChatCard>
      <ChatCard user='assistant'>
        <div className='w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 mx-auto gap-3'>
          {templatesData && templatesData.data.map((template) => (
            <TemplateCard key={template.template_id} template={template} onSelectTemplate={() => setTemplate(template)} />
          ))
          }
        </div>
      </ChatCard>
    </>
  )
}

export default TemplateSelection
